import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { X } from "lucide-react";
import { useSelector } from "react-redux";
import { extraLessonTaskReducer } from "../redux/slice/extraLessonTaskSlice";
import SEOHead from "../CommanComponents/SEOHead";
const THEMES = {
  active: {
    bg: "bg-yellow-500 hover:bg-yellow-500 text-gray-900",
    iconBg: "bg-yellow-400",
    badge: "bg-yellow-500 text-white",
  },
  completed: {
    bg: "bg-green-500 hover:bg-green-600 text-white",
    iconBg: "bg-white/20",
    badge: "bg-green-700 text-white",
  },
};

function ExtraPage() {
  const navigate = useNavigate();
  const contentValue = useSelector((state) => state.extra.value);
  const lessonValue = useSelector((state) => state.lesson.value);
  const dynamicPicture = `/extapicture/${contentValue.picture}`;
  const Extrabutton = [
    {
      id: 1,
      name: "True & False",
      nameTr: "Doğru & Yanlış",
      icon: "✅",
      isCompleted: lessonValue?.true_false ?? false, // true veya false durumunu kontrol ediyoruz
    },
    {
      id: 2,
      name: "Listen & Find",
      nameTr: "Dinle & Bul",
      icon: "🎧",
      isCompleted: lessonValue?.listen_find ?? false,
    },
    {
      id: 3,
      name: "Question & Answer",
      nameTr: "Soru & Cevap",
      icon: "⁉️",
      isCompleted: lessonValue?.answer_question ?? false,
    },
    // {
    //   id: 4,
    //   name: "Description",
    //   nameTr: "Tanımlama",
    //   icon: "💡",
    //   isCompleted: lessonValue?.description ?? false,
    // },
  ];
  const dispatch = useDispatch();
  const handleselectTask = (id) => {
    dispatch(extraLessonTaskReducer(id));
    navigate("/ExtraTaskPage");
  };
  // Redux'tan gelen küçük harfli key'ler ile butonları eşleştirdik

  return (
    <div
      className="flex flex-col px-5 gap-4 min-h-screen pb-10 bg-transparent"
      style={{ fontFamily: "'Quicksand', sans-serif" }}
    >
      <SEOHead
        title="Eğlenceli Ekstralar ve Aktiviteler"
        description="İlkokul öğrenciler için hazırlanan eğlenceli İngilizce bulmacalar, oyunlar, mini testler ve ekstra öğrenme araçları."
      />
      {/* Üst Header Alanı */}
      <div className="container mx-auto px-4 mt-6">
        <div className="bg-yellow-500 flex flex-row items-center justify-between gap-4 px-6 py-4 rounded-3xl shadow-lg border-b-4 border-orange-600/20">
          <div className="flex flex-col text-left">
            <h1 className="text-xl sm:text-2xl font-bold text-white drop-shadow-sm">
              Bölüm: {contentValue.title}
            </h1>
            <p className="text-white/90 text-xs sm:text-sm font-medium italic">
              Konu: {contentValue.descriptionTr}
            </p>
          </div>
          <button
            className="bg-white/90 w-11 h-11 flex items-center justify-center rounded-2xl
             text-red-500 shadow-md hover:bg-red-500 hover:text-white transition-all transform active:scale-90"
            onClick={() => navigate("/cartPage")}
          >
            <X size={28} strokeWidth={3} />
          </button>
        </div>
      </div>

      {/* Ana İçerik Kartı */}
      <div className="px-4 container mx-auto">
        <div className="bg-white w-full rounded-xl overflow-hidden p-2 md:p-10 shadow-sm">
          <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
            {/* Resim Bölümü */}

            <div
              className="md:col-span-2 relative w-full aspect-video md:h-80 overflow-hidden
             rounded-xl shadow-inner border-l-6 border-yellow-500"
            >
              <img
                src={dynamicPicture}
                alt={contentValue.title}
                className="w-full h-full  transition-transform duration-500"
              />
            </div>

            {/* Açıklama ve Butonlar Bölümü */}
            <div className="md:col-span-2 flex flex-col gap-4">
              {/* Dinamik Buton Listesi */}
              <div className="flex flex-col gap-3">
                {Extrabutton.map((item) => {
                  // Butonun tamamlanma durumuna göre temayı seçiyoruz
                  const currentTheme = item.isCompleted
                    ? THEMES.completed
                    : THEMES.active;

                  return (
                    <button
                      key={item.id}
                      onClick={() => handleselectTask(item.id)}
                      className={`flex items-center rounded-2xl transition-all duration-300 shadow-md hover:shadow-lg transform hover:-translate-y-0.5 w-full overflow-hidden ${currentTheme.bg}`}
                    >
                      <div className="grid grid-cols-6 w-full items-center text-left">
                        {/* İkon Alanı */}
                        <div
                          className={`col-span-2 text-2xl h-full min-h-[70px] flex items-center justify-center transition-colors ${currentTheme.iconBg}`}
                        >
                          <div className="p-2 bg-purple-600 rounded-full">
                            {item.icon}
                          </div>
                        </div>
                        {/* Yazı Alanı */}
                        <div className="col-span-4 p-3 flex flex-col justify-center">
                          <span className="font-bold text-sm sm:text-base leading-tight">
                            {item.name}
                          </span>
                          <div className="w-full my-1 border-t border-black/10" />
                          <span className="text-xs sm:text-sm opacity-90">
                            {item.nameTr}
                          </span>
                        </div>
                      </div>
                    </button>
                  );
                })}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default ExtraPage;
